module.exports = __webpack_public_path__ + "media/assets/images/message-viewed-icon-76d38a3ecda7630944940777b63c35d8.svg";